export enum DeviceType {
    Mobile,
    Desktop,
    Tablet,
}
